<template>
  <div class="devOpsSpace">
    <!-- #region 搜索 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="任务名称">
        <el-input placeholder="请输入" @keyup.enter.native="onSubmit" v-model="form.taskName"></el-input>
      </el-form-item>
      <el-form-item class="user" label="运维人员" prop="user">
        <el-select style="width: 100%" v-model="form.operatorId" collapse-tags multiple filterable @change="onSubmit"
                   placeholder="请输入运维人员">
          <el-option v-for="(key, value) in operatorUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="主域名">
        <el-select :style="iptStyle" collapse-tags v-model="form.domain" multiple filterable
                   @change="onSubmit('domain')" placeholder="请选择主域名">
          <el-option v-for="(value, key) in allSelect['TEXTDOMAINS']" :key="key" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="系统">
        <el-select @change="onSubmit" collapse-tags multiple filterable v-model="form.module" placeholder="请选择模块">
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option v-for="(key, val) in allSelect['TEXTFILTERMODULES']" :key="val" :label="key" :value="val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务状态">
        <el-select @change="onSubmit" v-model="form.status" placeholder="请选择任务状态">
          <el-option v-for="(item, index) in RELEASESTATUS" :key="index" :label="item"
                     :value="index" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布开始时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="form.deployTimeStart" @input="daterangeChange" type="date"
                        placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发布结束时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="form.deployTimeEnd" type="date" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="devOpsSpaceSearchFormBtn" style="margin-left:12px;" type="primary" @click="onSubmit">搜索
        </el-button>
      </el-form-item>
      <el-form-item v-if="space === 'developerSpace'">
        <el-button class="devOpsSpaceSearchFormBtn" type="primary" @click="formTaskClickFn('Create')">创建任务</el-button>
      </el-form-item>
      <el-form-item v-if="space === 'operatorSpace'">
        <el-button class="devOpsSpaceFullReleaseBtn" type="danger" @click="formTaskClickFn('FullRelease')">全量发布
        </el-button>
      </el-form-item>
      <el-form-item v-if="space === 'operatorSpace'">
        <el-button class="devOpsSpaceFullReleaseBtn" type="danger" @click="formTaskClickFn('Runurgent')">紧急发布
        </el-button>
      </el-form-item>
      <el-form-item v-if="space === 'operatorSpace'">
        <el-button class="devOpsSpaceOpenAllBtn" type="primary" @click="flagAllRowHandle">一键{{expands.length? '收缩'
            :'展开'}}
        </el-button>
      </el-form-item>
    </el-form>
    <!-- #endregion 搜索 -->
    <!-- #region 内容 -->
    <div class="devOpsSpaceContent">
      <el-table height="100%" row-key="id" :cell-style="getRowClass" :expand-row-keys="expands"
                @row-click="clickRowHandle" :data="list" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="devOpsSpaceRow">
              <div v-for="(itm, idx) in props.row.stage_info" :key="idx">
                <!-- 待修改 -->
                <Arrow v-if="itm.space === space" :arrowClick="arrowClickFn" :arrowParam="{
                  ...itm,
                  module_name: props.row.module,
                  stage: 'Step' + itm.stage_id,
                  task_id: props.row.taskId,
                  pid: props.row.demand_id,
                  domain:props.row.domain,
                  taskInfo:{
                    pid: props.row.demand_id,
                    user_pm:props.row.user_pm,
                    user_qa:props.row.user_qa,
                    module :props.row.module,
                    user_rd:props.row.user_rd,
                    id: props.row.taskId,
                    domain:props.row.domain,
                    space:'operatorSpace'
                  }
                }"
                       :arrowStyle="{ ...arrowStyle, background: statusColor[itm.state], height: arrowStyle.height, width: '140' }"
                       :arrowText="idx + 1 + '.' + itm.describe + '(' + statusMap[itm.state] + ')'" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="系统" align="center" prop="module">
          <template slot-scope="scope">
            <span style="color: red;" v-if="scope.row.urgentdeploy_switch === 'on'">*</span>
            {{ allSelect.TEXTMODULES[scope.row.module] }}
          </template>
        </el-table-column>
        <el-table-column label="需求ID" width="80" align="center" prop="project_url">
          <template slot-scope="scope">
            <div class="table_text_click" style="width:100%;text-align: center;" @click.stop="arrowClickFn({ ...scope.row, stage: 'Demand' })">
              {{ scope.row.demandId }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160" label="任务" prop="title">
          <template slot-scope="scope">
            <div class="table_text_click" @click.stop="arrowClickFn({ ...scope.row, stage: 'Task' })">
              [{{ scope.row.taskId }}] {{ scope.row.taskName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="期望发布时间" align="center" width="170" prop="deployApplyTime">
          <template slot-scope="scope">
            {{ scope.row.deployApplyTime }}
          </template>
        </el-table-column>
        <el-table-column label="实际发布时间" align="center" width="170" prop="deployTime">
          <template slot-scope="scope">
            {{ scope.row.deployTime }}
          </template>
        </el-table-column>
        <el-table-column label="产品" align="center" width="80"  prop="pm">
          <template slot-scope="scope">
            <div>{{ scope.row.pm.nameZh ? scope.row.pm.nameZh: '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="开发" align="center"  width="80" prop="developer">
          <template slot-scope="scope">
            <div>{{ scope.row.developer.nameZh ? scope.row.developer.nameZh: '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="测试" align="center"  width="80" prop="tester">
          <template slot-scope="scope">
            <div>
              <span v-for="(iten,index) in scope.row.tester">
                  {{ iten.nameZh ? iten.nameZh: '' }}
              </span>

            </div>
          </template>
        </el-table-column>
        <el-table-column label="运维" align="center"  width="80" prop="operator">
          <template slot-scope="scope">
            <div>{{ scope.row.operator.nameZh ? scope.row.operator.nameZh: '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="发布状态" align="center" prop="task_status" fixed="right">
          <template slot-scope="scope">
            <div>{{scope.row.deployStatus.desc ? scope.row.deployStatus.desc: ''}}</div>
            <!-- <div :style="scope.row.task_status === '已上线' && 'color:#67C23A;'">{{ scope.row.task_status }}</div>-->
          </template>
        </el-table-column>
        <el-table-column label="发布请示证明" align="center" width="180" prop="pdt_leader_proof" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-around;">
              <span class="table_text_click" style="text-align: center;" v-for="(item,index) in scope.row.pdt_leader_proof" :key="index" @click.stop="linkToHref(item)">附件{{index+1}}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 内容 -->
    <!-- #region 分页 -->
    <div class="block devOpsSpace_page">
      <el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage"
                     @size-change="handleSizeChange" :page-size="pageSize" layout="total, prev, pager, next , sizes" :total="count"
                     :page-sizes="[ 10, 15, 25, 35 ]">
      </el-pagination>
    </div>
    <!-- #endregion 分页 -->
    <!-- #region 弹窗部分 -->
    <Task v-if="dialogVisibleTask" :dialogVisible='dialogVisibleTask' :hideDialogVisible="hideDialogVisible"
          :formInfo="modelParam" />
    <ModelOne v-if="dialogVisibleStep1" :dialogVisible="dialogVisibleStep1" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelTwo v-if="dialogVisibleStep2" :dialogVisible="dialogVisibleStep2" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelThir v-if="dialogVisibleStep3" :dialogVisible="dialogVisibleStep3" :hideDialogVisible="hideDialogVisible"
               :modelParam="modelParam" />
    <ModelFour v-if="dialogVisibleStep4" :dialogVisible="dialogVisibleStep4" :hideDialogVisible="hideDialogVisible"
               :modelParam="modelParam" />
    <ModelOne v-if="dialogVisibleStep5" :dialogVisible="dialogVisibleStep5" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelFive v-if="dialogVisibleStep6" :dialogVisible="dialogVisibleStep6" :hideDialogVisible="hideDialogVisible"
               :modelParam="modelParam" />
    <ModelSix v-if="dialogVisibleStep7" :dialogVisible="dialogVisibleStep7" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelOne v-if="dialogVisibleStep8" :dialogVisible="dialogVisibleStep8" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelFive v-if="dialogVisibleStep9" :dialogVisible="dialogVisibleStep9" :hideDialogVisible="hideDialogVisible"
               :modelParam="modelParam" />
    <ModelSeven v-if="dialogVisibleStep10" :dialogVisible="dialogVisibleStep10" :hideDialogVisible="hideDialogVisible"
                :modelParam="modelParam" />
    <ModelSix v-if="dialogVisibleStep11" :dialogVisible="dialogVisibleStep11" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelTen v-if="dialogVisibleStep12" :dialogVisible="dialogVisibleStep12" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelEight v-if="dialogVisibleStep13" :dialogVisible="dialogVisibleStep13" :hideDialogVisible="hideDialogVisible"
                :modelParam="modelParam" />
    <ModelOne v-if="dialogVisibleStep14" :dialogVisible="dialogVisibleStep14" :hideDialogVisible="hideDialogVisible"
              :modelParam="modelParam" />
    <ModelFive v-if="dialogVisibleStep15" :dialogVisible="dialogVisibleStep15" :hideDialogVisible="hideDialogVisible"
               :modelParam="modelParam" />
    <ModelNine v-if="dialogVisibleStep16" :dialogVisible="dialogVisibleStep16" :hideDialogVisible="hideDialogVisible"
               :modelParam="modelParam" />
    <ModelSeven v-if="dialogVisibleStep17" :dialogVisible="dialogVisibleStep17" :hideDialogVisible="hideDialogVisible"
                :modelParam="modelParam" />
    <ProEnvTesting v-if="dialogVisibleStep18" :dialogVisible="dialogVisibleStep18"
                   :hideDialogVisible="hideDialogVisible" :formInfo="modelParam" />
    <ModelEleven v-if="dialogVisibleStep19" :dialogVisible="dialogVisibleStep19" :hideDialogVisible="hideDialogVisible"
                 :modelParam="modelParam" />
    <ModelCreate v-if="dialogVisibleCreate" :dialogVisible="dialogVisibleCreate"
                 :hideDialogVisible="hideDialogVisible" />
    <ModelFullRelease v-if="dialogVisibleFullRelease" :dialogVisible="dialogVisibleFullRelease"
                      :hideDialogVisible="hideDialogVisible" :modelParam="modelParam" />
    <ModelRunurgent v-if="dialogVisibleRunurgent" :dialogVisible="dialogVisibleRunurgent"
                    :hideDialogVisible="hideDialogVisible" :modelParam="modelParam" />
    <Demand v-if="dialogVisibleDemand" :dialogVisible='dialogVisibleDemand' :hideDialogVisible="hideDialogVisible"
            :formInfo="modelParam" />
    <!-- #endregion 弹窗部分 -->
  </div>
</template>
<script>
import { Arrow } from "@/components/index.js";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
import {
  ModelOne,
  ModelTwo,
  ModelThir,
  ModelFour,
  ModelFive,
  ModelSix,
  ModelSeven,
  ModelEight,
  ModelNine,
  ModelTen,
  ModelEleven,
  ModelCreate,
  ModelFullRelease,
  ModelRunurgent,
} from "./model/index.js";
import { Task, Demand, ProEnvTesting } from '../producerSpace/components'
import {
  getDevOpsSpaceListApi,
  getDevOpsSpaceDeployApplyApi,
} from "@/server/tops/devOps";
import { mapState, mapMutations } from "vuex";
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"
export default {
  name: "Space",
  components: {
    Arrow,
    Task,
    ModelOne,
    ModelTwo,
    ModelThir,
    ModelFour,
    ModelFive,
    ModelSix,
    ModelSeven,
    ModelEight,
    ModelNine,
    ModelCreate,
    ModelTen,
    ModelEleven,
    ModelFullRelease,
    ModelRunurgent,
    Demand,
    ProEnvTesting
  },
  props: {
    space: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      arrowStyle: {
        color: "#000",
        background: "#0e8706",
        fontSize: "12",
        height: "36",
        fontWeight: "normal",
        width: "212",
      },
      statusColor: {
        // 0:关闭, 1:开启, 2:完成, 3:跳过, 4:异常 5: 执行中
        0: "#cfd0d0",
        1: "#78bbff",
        2: "#6ac9b6",
        3: "gray",
        4: "#d26565",
        5: "rgb(72, 201, 214)",
      },
      statusMap: {
        0: "未开启",
        1: "运行中",
        2: "已通过",
        3: "已跳过",
        4: "异常",
        5: "执行中",
      },
      list: [],
      form: {
        deployTimeEnd: '',
        deployTimeStart: '',
        domain: '',
        taskName: '',
        operatorId: '',
        module: "",
        status: '0',
      },
      modelParam: {},
      // 弹窗部分
      dialogVisibleTask: false,
      dialogVisibleStep1: false,
      dialogVisibleStep2: false,
      dialogVisibleStep3: false,
      dialogVisibleStep4: false,
      dialogVisibleStep5: false,
      dialogVisibleStep6: false,
      dialogVisibleStep7: false,
      dialogVisibleStep8: false,
      dialogVisibleStep9: false,
      dialogVisibleStep10: false,
      dialogVisibleStep11: false,
      dialogVisibleStep12: false,
      dialogVisibleStep13: false,
      dialogVisibleStep14: false,
      dialogVisibleStep15: false,
      dialogVisibleStep16: false,
      dialogVisibleStep17: false,
      dialogVisibleStep18: false,
      dialogVisibleStep19: false,
      dialogVisibleCreate: false,
      dialogVisibleFullRelease: false,
      dialogVisibleRunurgent: false,
      dialogVisibleDemand: false,
      //  分页部分
      count: 10, // 总计
      currentPage: 1, // 当前页
      pageSize: 15, // 每页多少个
      tableData: [],
      // 要展开的行，数值的元素是row的key值
      expands: [],
      allData: {},
      operatorUser: {},
    };
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          allStatusList: (state) => state.devOps.ALLSTATUSLIST,
          RELEASESTATUS: (state) => state.devOps.RELEASESTATUS,
        }
    )
  },
  async mounted() {
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
    // 开发空间默认全部
    if (this.space === "developerSpace") {
      this.form.later_state = "";
    }
    const { later_state = "", id = "" } = this.$route.query;
    later_state && (this.form.later_state = later_state);
    this.form.title = id;
    this.form.deployTimeStart = this.getNowDate();
    this.getDevOpsSpaceAllUser();
    this.onSubmit();
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#f9f9f9;padding:2px";
    },
    // 扩展行
    clickRowHandle(row, column, event) {
      if (this.expands.includes(row.id)) {
        this.expands = this.expands.filter(val => val !== row.id);
      } else {
        this.expands.push(row.id);
      }
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type === 12){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.operatorUser = arr;
    },
    // 一键展开关闭
    flagAllRowHandle() {
      if (this.expands.length) {
        this.expands = []
      }else{
        let arr = [];
        this.list.forEach((item)=>{
          arr.push(item.id)
        })
        this.expands = arr;
      }
    },
    daterangeChange() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 列表获取
    async queryDevOpsSpaceInfo(params = {}) {
      try {
        this.$showLoading();
        const param = {
          space: this.space || "",
          title: params.title || "",
          user: params.user || "",
          status: params.status || "",
          module: params.module || "",
          pageNo: this.currentPage || 1,
          pageSize: this.pageSize || 15,
          pdt_start: params.pdt_start,
          pdt_end: params.pdt_end,
          domain: params.domain
        };
        const param2 = {
          ...this.form,
          pageNo: this.currentPage || 1,
          pageSize: this.pageSize || 15,
          operatorId: this.form.operatorId ? this.form.operatorId.toString(): '',
          domain: this.form.domain ? this.form.domain.toString(): '',
          module: this.form.module ? this.form.module.toString(): '',

        };
        if(param2.deployTimeEnd){
          param2.deployTimeEnd = param2.deployTimeEnd + ' 23:59:59';
        }
        const res = await getDevOpsSpaceDeployApplyApi(param2);
        this.list = (res?.data || []).map((item)=>{
          item.pdt_leader_proof = JSON.parse(item.pdt_leader_proof || '[]').map(itm=>{
            return itm.response.url
          })
          return item;
        });
        this.count = res?.count || 0;
      } catch (error) {
        this.$notify({
          message: error || "网络异常，请稍后重试",
          type: "error",
        });
      } finally {
        this.$hideLoading();
      }
    },
    // 表单搜索事件
    async onSubmit(type) {
      if (type === 'domain') {
        this.filterSelect({ type: 'domain_module', val: this.form.domain })
      }
      const {
        title = "",
        user = [],
        later_state = "",
        module = "",
        pdt_end = '',
        pdt_start = '',
        domain = [],
        status = '',
      } = this.form;
      const params = {
        title,
        user: user.toString(),
        status,
        module: module.toString(),
        pdt_end,
        pdt_start,
        domain: domain.toString()
      };
      await this.queryDevOpsSpaceInfo(params);
    },
    // 全量发布事件 创建任务事件
    formTaskClickFn(type) {
      this["dialogVisible" + type] = true;
    },
    // 任务事件
    arrowClickFn(val) {
      const { stage = "", state = "", project_url = '', id = '', progress = '', space = '', task_progress = '', status = '', task_status = '', taskId = '' , taskName = '', demandId = ''} = val;
      if (state === 0) return;
      let modelParam = val
      if (stage === 'Demand') {
        modelParam = {name : '', id: demandId}

       // modelParam = { id: project_url, progress, space }
      }
      if (stage === 'Task') {
        modelParam.taskInfo  = {taskId: taskId,name:taskName}
       // modelParam.taskInfo = { pid: project_url, id, task_progress, status: task_status }
      }
      this.modelParam = modelParam;
      this["dialogVisible" + stage] = true;
    },
    // 弹窗隐藏事件
    async hideDialogVisible(dialogVisible) {
      this['dialogVisibleDemand'] = false;
      this[dialogVisible] = false;
      if (!dialogVisible) {
        this['dialogVisibleTask'] = false;
        this['dialogVisibleDemand'] = false;
        this['dialogVisibleStep18'] = false;
      }
      await this.onSubmit();
    },
    // 分页事件
    handleCurrentChange(val) {
      console.log(this.currentPage);
      console.log(`当前页: ${val}`);
      this.onSubmit();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.onSubmit();
    },
    // 头部文案
    arrowHeadTextFn(val) {
      const {
        id = "",
        priority = "",
        module = "",
        user = "",
        space = "",
        pdt = "",
      } = val;
      let str = `[${id}][${priority}][${module.toLocaleUpperCase()}][${user}]`;
      if (space === "operatorSpace") {
        let time = this.$moment(pdt).format("DD/HH");
        str = `[${id}][${time}][${module.toLocaleUpperCase()}][${user}]`;
      }
      return str;
    },
    // 跳转外部连接
    linkToHref(item){
      window.open(item)
    },
    formatEnToUtf8
  },
};
</script>
<style lang="scss" scoped>
.devOpsSpace {
  display: flex;
  flex-direction: column;
  background: #fff;

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    width: fit-content;
  }

  .devOpsSpace_page {
    text-align: right;
    margin-top: 20px;
    margin-right: 20px;
  }

  .devOpsSpaceRow {
    display: flex;
    flex-wrap: wrap;
    margin-left: 7%;
  }

  .form_warp {
    //margin-top: 10px;
  }

  .devOpsSpaceContent {
    height: 78vh;
    overflow-y: auto;

    .priority_style {
      border-radius: 5px;
      text-align: center;
      width: fit-content;
      padding: 0 5px;
      margin: auto;
      white-space: nowrap;
      display: inline-block;
    }


  }
}
</style>
<style lang="scss">
.devOpsSpace {
  height: 100%;

  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .user {
    .el-input__inner {
      margin-left: -5px;
    }

    .el-form-item__label {
      margin-right: 5px;
    }
  }

  .el-pagination__total {
    font-weight: bold;
  }

  .form_warp {
    .el-form-item {
      margin-bottom: 6px;
    }

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-input__inner {
      width: 140px !important;
    }

    .el-form-item__label {
      font-weight: bold !important;
      font-size: 14px;
    }

    .devOpsSpaceSearchFormBtn,
    .devOpsSpaceFullReleaseBtn,
    .devOpsSpaceOpenAllBtn {
      letter-spacing: 2px;
      font-weight: bold;
      font-size: 14px;
    }

  }

  .tips-message::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .tips-message,
  .devOpsSpaceContent {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;

    .el-table__expanded-cell {
      padding: 0 !important;
      // padding-left: 80px !important;
    }
  }

  .websocket_style {
    background-color: #333;
    color: #fefefe;
    padding: 8px;

    a {
      color: #e6a23c;
    }
  }

  .devOpsSpaceContent::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .devOpsSpaceContent::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .devOpsSpaceContent::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}

// #region 滚动条
.tips-message {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

// #endregion
</style>
